module.exports = __webpack_public_path__ + "img/timeline-19.6c06f9fb.svg";